export const APP_TITLE = 'iStaff';
export const API_URL = import.meta.env.VITE_API_URL;
export const DEMO_VALUE = import.meta.env.VITE_DEMO_VALUE;
export const ENABLE_MOCKING = import.meta.env.VITE_ENABLE_MOCKING === 'true';
export const MOCK_DELAY = import.meta.env.VITE_MOCK_DELAY;
